import React from "react";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Metrics from "../components/Metrics";
import Certifications from "../components/Certifications";
import Projects from "../components/Projects";
import GlobalPresence from "../components/GlobalPresence";
import Careers from "../components/Careers";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-[#0A0A0B] min-h-screen text-[#F4F4F5]">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Services />
        <Metrics />
        <Certifications />
        <Projects />
        <GlobalPresence />
        <Careers />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
